import { TpValue } from "@/dentlab/src/types/enums";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { InputWrapper } from "@/dentlab/src/components/input-wrapper";
import { CustomToggleButtonGroup } from "@/dentlab/src/components/custom-toggle-button/custom-toggle-button-group.component";

export const JobInfoTpValue: React.FC<{
	inputHeight?: number;
	validationError?: string | null;
}> = ({ inputHeight, validationError }) => {
	const { job, updateJobFields, updateJobItems } = useJobStore((state) => ({
		job: state.job,
		updateJobFields: state.updateJobFields,
		updateJobItems: state.updateJobItems,
	}));

	const handleChange = async (value: number | null) => {
		if (!job?.id || value == null) return;
		updateJobFields({ tp_value: value });
		await updateJobItems(job.id as number, value, undefined);
	};

	return (
		<InputWrapper label="TP-Wert" validationError={validationError}>
			<CustomToggleButtonGroup
				value={job?.tp_value}
				onChange={handleChange}
				options={[
					{ value: TpValue.OLD, label: "5.55" },
					{ value: TpValue.NEW, label: "1.0" },
				]}
				isInput
				inputHeight={inputHeight}
				ariaLabel="TP-Wert"
				testId="job-info-tp-value"
				invalid={!!validationError}
			/>
		</InputWrapper>
	);
};
